import { useMutation } from '@tanstack/react-query';
import { updateStock } from '../api/repository/stock';
import { UpdateStockInterface } from '../types/stock';

type UpdateStockProps = {
    stockNumber: string;
    stock: UpdateStockInterface;
};

export const useUpdateStock = () => {
    return useMutation({
        mutationFn: ({ stockNumber, stock }: UpdateStockProps) =>
            updateStock(stockNumber, stock),
    });
};
